module.exports = __webpack_public_path__ + "static/media/sedeni-dinardo.e23354d1.jpg";